import { render, staticRenderFns } from "./CollectionElementsList.vue?vue&type=template&id=4bc3fd20&scoped=true&"
import script from "./CollectionElementsList.vue?vue&type=script&lang=js&"
export * from "./CollectionElementsList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionElementsList.vue?vue&type=style&index=0&id=4bc3fd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3fd20",
  null
  
)

export default component.exports